// apps/lk/src/lib/api.ts
// LK-специфичные эндпоинты. Общее ядро — в @tb/ui/api-core
import {
  CompaniesService,
  TestResultsService,
  TestsService,
} from '@tb/api-client/client';
import {
  withToken,
  fetchWithToken,
  auth,
  extractToken,
  setToken,
  getToken,
} from '@tb/ui/api-core';

const BASE = () => process.env.NEXT_PUBLIC_API_URL || 'http://localhost:4000';

export const api = {
  // ===== AUTH (из общего ядра) =====
  ...auth,

  // ===== TESTS =====
  listTests: () => withToken(TestsService.testsControllerList)({}),
  listCategories: () => withToken(TestsService.testsControllerCategories)(),
  testOne: (id: string) => withToken(TestsService.testsControllerOne)({ id }),

  // ===== TEST RESULTS =====
  submit: (testId: string, body: any) =>
    withToken(TestResultsService.testResultsControllerSubmit)({ id: testId, requestBody: body }),
  // Динамика: все попытки по тесту (ASC по дате)
  testHistory: (testId: string) => fetchWithToken(`/api/tests/${testId}/history`),
  // Проверка свежих результатов (≤90 дней) для тестов
  checkFresh: (testIdsCsv: string) =>
    fetchWithToken(`/api/tests/check-fresh?testIds=${encodeURIComponent(testIdsCsv)}`),

  // ===== INVITES =====
  applyByInvite: (inviteToken: string) =>
    fetchWithToken('/api/companies/invite/apply', {
      method: 'POST',
      body: JSON.stringify({ inviteToken }),
    }),
  redeemInvite: async (token: string, code?: string) => {
    // BASE() = https://api.team-builder.ru (БЕЗ /api) — добавляем префикс + Bearer
    const url = `${BASE()}/api/invite?token=${encodeURIComponent(token)}${code ? `&code=${encodeURIComponent(code)}` : ''}`;
    const headers: Record<string, string> = {};
    const t = getToken();
    if (t) headers.Authorization = `Bearer ${t}`;
    const res = await fetch(url, { headers });
    const json = await res.json();
    if (!res.ok) throw { body: json, status: res.status };
    return json;
  },

  // ===== ДАШБОРД (новый эндпоинт — читает напрямую из спец-таблиц) =====
  dashboard: () => fetchWithToken('/api/assessment/dashboard'),

  // ===== СИНТЕЗ (кросс-тестовый анализ — все 4 теста) =====
  synthesis: () => fetchWithToken('/api/assessment/synthesis'),

  // ===== ASSESSMENT (description — для TestResult после submit) =====
  aspectDescription: (testSlug: string, aspectKey: string, gradation: string, value?: number) => {
    const params = new URLSearchParams({ test: testSlug, aspect: aspectKey, gradation });
    if (value != null) params.set('value', String(value));
    return fetchWithToken(`/api/assessment/description?${params}`);
  },

  // ===== КОМПАНИИ (пользовательская сторона) =====
  myCompanies: () => withToken(CompaniesService.companiesControllerMy)(),
  joinCompany: (companyId: string, joinCode: string, joinPassword?: string) =>
    fetchWithToken(`/api/companies/${companyId}/join`, {
      method: 'POST',
      body: JSON.stringify({ joinCode, ...(joinPassword ? { joinPassword } : {}) }),
    }),
  confirmMembership: (companyId: string, membershipId?: string) =>
    fetchWithToken(`/api/companies/${companyId}/members/confirm`, {
      method: 'POST',
      body: JSON.stringify(membershipId ? { membershipId } : {}),
    }),
  findCompanyByCode: (code: string) =>
    fetchWithToken(`/api/companies/by-code/${encodeURIComponent(code)}`),

  // ===== ЗАЯВКИ (кандидатская сторона найма) =====
  myApplications: () => fetchWithToken('/api/my/applications'),
  applicationOne: (cid: string) => fetchWithToken(`/api/my/applications/${cid}`),
};

export { extractToken, setToken, getToken };
